export enum CarouselType {
  CLASS = 'class',
  COURSE = 'course',
  PROMOTION_COURSE = 'promotion-course',
  DASHBOARD_ITEM = 'dashboard-item',
  WEBINAR = 'webinar',
  CUSTOM = 'custom'
}
